import Splide from '@splidejs/splide';

export const initReviewsCarousel = () => {
  const reviewsSliderEl = document.querySelector(
    '[data-pro-single-family-reviews-carousel-slider]'
  );

  const reviewsSlider = new Splide(reviewsSliderEl, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 300,
    autoplay: true,
    interval: 5000,
    rewind: true,
    arrows: false,
    pagination: true,
    classes: {
      pagination:
        'splide__pagination pro-single-family-reviews-carousel__slider-pagination',
      page: 'splide__pagination__page pro-single-family-reviews-carousel__slider-pagination-btn',
    },
  });

  reviewsSlider.mount();

  const { GoogleAnalytics } = window;

  reviewsSlider.event.on('move', () => {
    const { Autoplay } = reviewsSlider.Components;

    if (Autoplay.isPaused()) {
      GoogleAnalytics.trackEvent(
        'For Pros - Single Family',
        'Click',
        'Customers Reviews'
      );
    }
  });
};
